import {
  Button,
  ButtonOwnProps,
  Dialog,
  DialogActions,
  DialogContent,
  Grid2,
  IconButton,
  Typography,
} from "@mui/material";
import { IconX } from "@tabler/icons-react";

import Loading from "./Loading";

const ModalConfirm = ({
  open,
  onClose,
  onAction,
  title,
  description,
  loading,
  buttonColor = "error",
  buttonTitle,
}: {
  open: boolean;
  onClose: () => void;
  onAction: () => void;
  title: string;
  description?: string;
  loading?: boolean;
  buttonTitle: string;
  buttonColor?: ButtonOwnProps["color"];
}) => (
  <Dialog maxWidth="xs" open={open} onClose={onClose}>
    {loading && <Loading loading={loading} />}
    <DialogContent sx={{ backgroundColor: "secondary.main" }}>
      <Grid2 container spacing={2}>
        <Grid2 size={{ xs: 10, md: 11 }}>
          <Typography variant="h2" fontSize={26} fontWeight={600}>
            {title}
          </Typography>
        </Grid2>
        <Grid2 size={{ xs: 2, md: 1 }}>
          <IconButton onClick={onClose}>
            <IconX style={styles.iconStyle} />
          </IconButton>
        </Grid2>
        <Grid2 size={12}>
          <Typography variant="subtitle1" color="secondary.contrastText">
            {description}
          </Typography>
        </Grid2>
      </Grid2>
    </DialogContent>
    <DialogActions sx={{ backgroundColor: "secondary.main", padding: 2 }}>
      <Button
        fullWidth
        variant="contained"
        size="large"
        color={buttonColor}
        onClick={onAction}
      >
        {buttonTitle}
      </Button>
    </DialogActions>
  </Dialog>
);

const styles = {
  stackStyle: {
    flexDirection: "row",
    alignItems: "center",
    gap: 1,
    padding: 1,
    borderRadius: 2,
  },
  iconStyle: {
    color: "primary.main",
  },
};

export default ModalConfirm;
